import React, { useEffect, useState } from "react";
import VouchCard from "../components/VouchCard";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";

const SHOP = {
  name: "Better Warzone Audio",
  subtitle: "Best Service | Since 2024",
  score: "5.0 / 5.0",
  icon: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
};

const categories = [
  "Alle",
  "Allgemein",
  "Service",
  "Support",
  "Zahlung",
  "Lieferung",
  "Sonstiges"
];

export default function Home() {
  const [vouches, setVouches] = useState([]);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [filterCat, setFilterCat] = useState("Alle");
  const [filterStars, setFilterStars] = useState("Alle");
  const [sort, setSort] = useState("Neueste");

  useEffect(() => {
    const vouchRef = ref(db, "vouches");
    const unsubscribe = onValue(vouchRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setVouches(Object.values(data));
      } else {
        setVouches([]);
      }
    }, (err) => setError("Fehler beim Laden der Datenbank."));
    return () => unsubscribe();
  }, []);

  // Filter und Sortierung
  let filtered = vouches.filter(v =>
    (filterCat === "Alle" || v.category === filterCat) &&
    (filterStars === "Alle" || v.rating === Number(filterStars)) &&
    (search === "" || (v.name && v.name.toLowerCase().includes(search.toLowerCase())))
  );

  if (sort === "Neueste") filtered = filtered.slice().reverse();
  if (sort === "Älteste") filtered = filtered.slice();
  if (sort === "Beste Bewertung") filtered = filtered.slice().sort((a, b) => b.rating - a.rating);

  // Statistik
  const avgRating = filtered.length
    ? (filtered.reduce((sum, v) => sum + Number(v.rating), 0) / filtered.length).toFixed(2)
    : "0.00";
  const topCat = filtered.length
    ? Object.entries(filtered.reduce((acc, v) => {
        acc[v.category] = (acc[v.category] || 0) + 1;
        return acc;
      }, {})).sort((a, b) => b[1] - a[1])[0][0]
    : "-";

  // Top 3 User
  const topUsers = Object.entries(
    filtered.reduce((acc, v) => {
      acc[v.name] = (acc[v.name] || 0) + 1;
      return acc;
    }, {})
  )
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3);

  return (
    <div className="home-container">
      {/* Großer Titel und Untertitel */}
      <div style={{
        textAlign: "center",
        marginBottom: "1.7rem"
      }}>
        <h1 style={{
          fontSize: "2.7rem",
          color: "#FF0000",
          fontWeight: "bold",
          letterSpacing: "2px",
          marginBottom: "0.3rem"
        }}>Better Vouches</h1>
        <div style={{
          color: "#bdbdbd",
          fontSize: "1.25rem",
          fontWeight: "500"
        }}>
          Die Plattform für ehrliche Bewertungen und Community-Feedback.
        </div>
      </div>
      {/* Topbar noch dunkler, animiert */}
      <div style={{
        background: "linear-gradient(90deg, #0a0a0c 0%, #151517 100%)",
        borderRadius: "0.18rem",
        boxShadow: "0 4px 32px #000c",
        padding: "1.1rem 2.2rem",
        marginBottom: "1.2rem",
        display: "flex",
        alignItems: "center",
        gap: "2.2rem",
        justifyContent: "flex-start",
        position: "relative"
      }}>
        {/* Assassin's Creed Style Icon */}
        <span style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "3.2rem",
          height: "3.2rem",
          borderRadius: "50%",
          background: "#0a0a0c",
          border: "2px solid #FF0000",
          marginRight: "1.2rem",
          boxShadow: "0 0 24px 0 #FF000055"
        }}>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16 3L21.5 19.5L16 16L10.5 19.5L16 3Z" fill="#FF0000" />
            <path d="M16 16L21.5 19.5L16 29L10.5 19.5L16 16Z" fill="#fff" fillOpacity="0.12"/>
          </svg>
        </span>
        <div style={{
          width: "3.2rem",
          height: "3.2rem",
          borderRadius: "50%",
          background: "#0a0a0c",
          boxShadow: "0 0 0 0 #FF0000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid #FF0000",
          animation: "avatarGlow 2.2s infinite alternate"
        }}>
          <img src={SHOP.icon} alt="Shop Icon" style={{
            width: "2.5rem",
            height: "2.5rem",
            borderRadius: "50%",
            objectFit: "cover"
          }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{
            fontWeight: "bold",
            fontSize: "1.35rem",
            color: "#FF0000",
            letterSpacing: "1px",
            marginBottom: "0.2rem"
          }}>{SHOP.name}</div>
          <div style={{
            color: "#bdbdbd",
            fontSize: "1.05rem",
            marginBottom: "0.2rem"
          }}>{SHOP.subtitle}</div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "1.1rem"
        }}>
          <span style={{
            color: "#FF0000",
            fontWeight: "bold",
            fontSize: "1.05rem",
            display: "flex",
            alignItems: "center"
          }}>
            <span style={{
              display: "inline-block",
              marginRight: "0.3rem",
              animation: "starPulse 1.2s infinite alternate"
            }}>★</span>
            {SHOP.score}
          </span>
          <span style={{
            color: "#fff",
            fontSize: "1.05rem"
          }}>
            {vouches.length} Vouches
          </span>
          <span style={{
            fontSize: "1.2rem",
            color: "#FF0000"
          }}>🏆</span>
        </div>
        {/* Bewertung abgeben Button oben rechts */}
        <Link to="/bewertung-geben" style={{
          marginLeft: "2rem",
          background: "#FF0000",
          color: "#fff",
          borderRadius: "0.18rem",
          padding: "0.7rem 2.2rem",
          fontWeight: "bold",
          textDecoration: "none",
          fontSize: "1.15rem",
          boxShadow: "0 0 12px #FF0000",
          letterSpacing: "1px"
        }}>
          Bewertung abgeben
        </Link>
      </div>
      {/* Statistik-Box */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: "2.5rem",
        marginBottom: "2.2rem"
      }}>
        <div style={{
          background: "#151517",
          borderRadius: "0.18rem",
          border: "1.5px solid #23232a",
          color: "#fff",
          padding: "1.1rem 2.2rem",
          minWidth: "180px",
          textAlign: "center"
        }}>
          <div style={{ color: "#bdbdbd", fontSize: "1.05rem" }}>Durchschnitt</div>
          <div style={{ color: "#FF0000", fontWeight: "bold", fontSize: "1.25rem" }}>{avgRating} ★</div>
        </div>
        <div style={{
          background: "#151517",
          borderRadius: "0.18rem",
          border: "1.5px solid #23232a",
          color: "#fff",
          padding: "1.1rem 2.2rem",
          minWidth: "180px",
          textAlign: "center"
        }}>
          <div style={{ color: "#bdbdbd", fontSize: "1.05rem" }}>Vouches</div>
          <div style={{ color: "#FF0000", fontWeight: "bold", fontSize: "1.25rem" }}>{filtered.length}</div>
        </div>
        <div style={{
          background: "#151517",
          borderRadius: "0.18rem",
          border: "1.5px solid #23232a",
          color: "#fff",
          padding: "1.1rem 2.2rem",
          minWidth: "180px",
          textAlign: "center"
        }}>
          <div style={{ color: "#bdbdbd", fontSize: "1.05rem" }}>Top Kategorie</div>
          <div style={{ color: "#FF0000", fontWeight: "bold", fontSize: "1.25rem" }}>{topCat}</div>
        </div>
        <div style={{
          background: "#151517",
          borderRadius: "0.18rem",
          border: "1.5px solid #23232a",
          color: "#fff",
          padding: "1.1rem 2.2rem",
          minWidth: "180px",
          textAlign: "center"
        }}>
          <div style={{ color: "#bdbdbd", fontSize: "1.05rem" }}>Top 3 User</div>
          <div style={{ color: "#FF0000", fontWeight: "bold", fontSize: "1.1rem" }}>
            {topUsers.map(([name, count], i) => (
              <span key={name}>{i + 1}. {name} ({count})<br /></span>
            ))}
          </div>
        </div>
      </div>
      {/* Filter, Sortierung, Suche */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: "2.2rem",
        marginBottom: "2.2rem"
      }}>
        <select value={filterCat} onChange={e => setFilterCat(e.target.value)} style={{
          background: "#151517",
          color: "#FF0000",
          border: "1.5px solid #23232a",
          borderRadius: "0.18rem",
          padding: "0.5rem 1.1rem",
          fontWeight: "bold"
        }}>
          {categories.map(cat => <option key={cat}>{cat}</option>)}
        </select>
        <select value={filterStars} onChange={e => setFilterStars(e.target.value)} style={{
          background: "#151517",
          color: "#FF0000",
          border: "1.5px solid #23232a",
          borderRadius: "0.18rem",
          padding: "0.5rem 1.1rem",
          fontWeight: "bold"
        }}>
          <option>Alle</option>
          <option>5</option>
          <option>4</option>
          <option>3</option>
          <option>2</option>
          <option>1</option>
        </select>
        <select value={sort} onChange={e => setSort(e.target.value)} style={{
          background: "#151517",
          color: "#FF0000",
          border: "1.5px solid #23232a",
          borderRadius: "0.18rem",
          padding: "0.5rem 1.1rem",
          fontWeight: "bold"
        }}>
          <option>Neueste</option>
          <option>Älteste</option>
          <option>Beste Bewertung</option>
        </select>
        <input
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Suche Username..."
          style={{
            background: "#151517",
            color: "#fff",
            border: "1.5px solid #23232a",
            borderRadius: "0.18rem",
            padding: "0.5rem 1.1rem",
            fontWeight: "bold"
          }}
        />
      </div>
      {/* Bewertungen Grid */}
      {error ? (
        <div style={{
          color: "#FF0000",
          background: "#23232a",
          borderRadius: "1rem",
          padding: "2rem",
          textAlign: "center",
          marginBottom: "2rem"
        }}>
          <b>Fehler:</b> {error}
        </div>
      ) : (
        <div className="vouch-grid-3">
          {filtered.map((vouch, idx) => (
            <VouchCard vouch={vouch} idx={filtered.length - idx} key={idx} />
          ))}
        </div>
      )}
      {/* Counter unter dem Grid */}
      <div style={{
        textAlign: "center",
        color: "#bdbdbd",
        fontSize: "1.08rem",
        marginTop: "2.2rem"
      }}>
        Insgesamt <span style={{ color: "#FF0000", fontWeight: "bold" }}>{filtered.length}</span> Vouches
      </div>
      {/* Footer mit Social Links, fixiert */}
      <footer style={{
        background: "#0a0a0c",
        color: "#bdbdbd",
        padding: "1.2rem 0",
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 20,
        borderTop: "1.5px solid #23232a",
        boxShadow: "0 -2px 24px #000a"
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1.5rem"
        }}>
          {/* Brand */}
          <div style={{ fontWeight: "bold", color: "#FF0000", fontSize: "1.15rem" }}>
            <span style={{ marginRight: "0.7rem", verticalAlign: "middle" }}>
              <svg width="22" height="22" viewBox="0 0 32 32" fill="none" style={{ verticalAlign: "middle" }}>
                <path d="M16 3L21.5 19.5L16 16L10.5 19.5L16 3Z" fill="#FF0000" />
                <path d="M16 16L21.5 19.5L16 29L10.5 19.5L16 16Z" fill="#fff" fillOpacity="0.12"/>
              </svg>
            </span>
            Better Vouches &copy; {new Date().getFullYear()}
          </div>
          {/* Social */}
          <div>
            <a href="#" style={{ color: "#FF0000", margin: "0 1.2rem", textDecoration: "none" }}>Discord</a>
            <a href="#" style={{ color: "#FF0000", margin: "0 1.2rem", textDecoration: "none" }}>YouTube</a>
            <a href="#" style={{ color: "#FF0000", margin: "0 1.2rem", textDecoration: "none" }}>TikTok</a>
          </div>
          {/* Kontakt */}
          <div>
            Kontakt: <a href="mailto:raspyy.dev@gmail.com" style={{ color: "#FF0000", textDecoration: "none" }}>raspyy.dev@gmail.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
